var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { LetrEditrequestType, LetrRequestType } from "@/share/Letr";
import { Group } from "@@/Group";
import { LeterPermissionType } from "@@/Letr";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { LetrUI } from "./LetrUI";
export class AssignedDetailsStore {
    constructor() {
        this.loading = false;
        this.removing = false;
        this.adding = false;
        this.allowSelEdit = false;
        this.showmenu = false;
        makeObservable(this);
        APPEvent.addSubscriberForLetrsResponse((res) => {
            var _a;
            if (res.type === LetrRequestType.FetchDetail && res.letrdetail !== undefined &&
                res.letrid === ((_a = this.activeLetr) === null || _a === void 0 ? void 0 : _a.id)) {
                this.setLetrDetail(res.letrdetail);
                this.setLoading(false);
            }
        });
        APPEvent.addSubscriberForLetrEdit((res) => {
            this.setAdding(false);
            this.setRemoving(false);
            if (res.detail !== undefined) {
                this.setLetrDetail(res.detail);
            }
            this.setSelectedGroup(undefined);
        });
        this.dialogState = new BaseDialogState();
        this.dialogState.setHeaderLabel("Assigned Details");
        this.dialogState.setHideFooter(true);
        this.dialogState.onClose = () => {
            this.setSelectedGroup(undefined);
            this.setShowMenu(false);
        };
    }
    toggleMenu() {
        this.setShowMenu(!this.showmenu);
    }
    setShowMenu(show) {
        this.showmenu = show;
    }
    setSelectedGroup(grp) {
        this.selectedGroup = grp;
        console.log(grp);
        this.setShowMenu(false);
    }
    setAllowEdit(allow) {
        this.allowSelEdit = allow;
    }
    setRemoving(remov) {
        this.removing = remov;
    }
    setAdding(add) {
        this.adding = add;
    }
    setLetrDetail(letrDetail) {
        this.letrDetails = letrDetail;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setActiveLetr(letr) {
        this.activeLetr = letr;
    }
    loadLetr() {
        if (!this.activeLetr) {
            return;
        }
        this.setLoading(true);
        const req = {
            type: LetrRequestType.FetchDetail,
            letrid: this.activeLetr.id
        };
        Apphandler.sendMessage("letrs", req);
    }
    removeMember(id) {
        if (this.removing || !this.activeLetr || this.adding) {
            return;
        }
        this.setRemoving(true);
        const req = {
            type: LetrEditrequestType.Delete,
            memberid: [{ userid: id, permission: LeterPermissionType.Edit, roleid: '' }],
            letrid: this.activeLetr.id,
            isConnect: false
        };
        Apphandler.sendMessage("letredit", req);
    }
    addMember(id) {
        if (this.removing || !this.activeLetr || this.adding) {
            return;
        }
        this.setAdding(true);
        const req = {
            type: LetrEditrequestType.Add,
            memberid: [id],
            letrid: this.activeLetr.id,
            isConnect: false
        };
        Apphandler.sendMessage("letredit", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", LetrUI)
], AssignedDetailsStore.prototype, "activeLetr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AssignedDetailsStore.prototype, "letrDetails", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AssignedDetailsStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AssignedDetailsStore.prototype, "removing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AssignedDetailsStore.prototype, "adding", void 0);
__decorate([
    observable,
    __metadata("design:type", Group)
], AssignedDetailsStore.prototype, "selectedGroup", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AssignedDetailsStore.prototype, "allowSelEdit", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AssignedDetailsStore.prototype, "showmenu", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AssignedDetailsStore.prototype, "setShowMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssignedDetailsStore.prototype, "setSelectedGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AssignedDetailsStore.prototype, "setAllowEdit", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AssignedDetailsStore.prototype, "setRemoving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AssignedDetailsStore.prototype, "setAdding", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AssignedDetailsStore.prototype, "setLetrDetail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AssignedDetailsStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [LetrUI]),
    __metadata("design:returntype", void 0)
], AssignedDetailsStore.prototype, "setActiveLetr", null);
